export const DEFAULT_ICON_SIZE = 16;
export const DEFAULT_LARGE_ICON_SIZE = 24;
export const DEFAULT_LOCALE = 'en-US';
